import React, { createRef, useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";

import { Datatable } from "../../../shared/datatable/Datatable";
import { convertUtcToLocalDateTime } from "../../../utils/utils";
import { assessmentDetail, resultBulkPublish, resultBulkUnPublish, runAssessmentClientList } from "../../../shared/settings/apiConfig";
import { getApi, putApi } from "../../../shared/services/apiHelper";

import './RunAssessmentClientView.scss';

const statusClassMapping = {
    'Not Started': 'status-not-started',
    'In Progress': 'status-in-progress',
    'Completed': 'status-completed',
    'Expired': 'status-expired',
};

const RunAssessmentClientView = (props) => {
    const reportValue = props.match.params.reportValue;
    
    const customName = (data) => {
        return data.firstname + ' ' + data.lastname;
    };

    const customStatus = (value) => {
        return <span className={statusClassMapping[value]}>{value}</span>
    };

    const customPublish = (row) => {
        return (
            row.resultid ? 
            <Form.Check type="checkbox" defaultChecked={row.ispublished ? true : false} onChange={(event) => {
                if ( row.ispublished ) {
                    setUnPublishResultIds(prevState => {
                        let index = prevState.indexOf(row.resultid);
                        if ( index > -1 ) {
                            prevState.splice(index, 1);
                        } else {
                            prevState.push(row.resultid);
                        }
    
                        return [...prevState];
                    });
                } else {
                    setPublishResultIds(prevState => {
                        let index = prevState.indexOf(row.resultid);
                        if ( index > -1 ) {
                            prevState.splice(index, 1);
                        } else {
                            prevState.push(row.resultid);
                        }
    
                        return [...prevState];
                    });
                }
            }}/> : null
        )
    };

    const customScoreColumn = (row) => {
        return (
            <div className="fw-bold">{row.score}/{row.totalscore}</div>
        )
    };

    const customAction = (row) => {
        return (
            row.resultid ? 
                row.resultstatus !== 'Completed' ?
                (
                    <div className="d-flex align-items-center gap-2 text-warning">
                        <Spinner />
                        <span className="">Processing</span>
                    </div>
                ) : 
                (
                <div className="d-flex gap-2">
                    <div role={"button"} className="text-s action-link" onClick={()=>{ props.history.push(`/scheduler/client/view/result/${row.resultid}`); }}>Detail</div>
                    </div>
                )
            : null
        )
    };

    const [assessment, setassessment] = useState({});
    const [publishResultIds, setPublishResultIds] = useState([]);
    const [unPublishResultIds, setUnPublishResultIds] = useState([]);

    const [config, setConfig] = useState({
        name: 'run-assessment-client',
        url: runAssessmentClientList,
        columns: [
            { name: 'Name', property: null, sort: false, width: '20%', customColumn: customName },
            { name: 'Number', property: 'clientnumber', sort: false, width: '20%' },
            { name: 'Attempt Date', property: 'starttime', sort: false, width: '15%', customColumn: convertUtcToLocalDateTime },
            { name: 'Status', property: 'runstatus', sort: false, width: '15%', customColumn: customStatus },
            { name: 'Publish / Un Publish', property: null, sort: false, width: '12%', customColumn: customPublish },
            { name: 'Score', property: '', sort: false, width: '8%', customColumn: customScoreColumn },
            {
                name: '', property: '', width: '10%', columnType: 'actions', actions: {
                    row: [
                        { type: 'custom', action: customAction }
                    ]
                }
            }
        ],
        field: ["id", "starttime", "runstatus", "runassessmentid", "runid", "creatorid", "clientid", "firstname", "lastname", "clientnumber", "resultid", "ispublished", "score", "totalscore", "resultstatus"],
        filter: [
            reportValue ?  {
                "field": "runstatus",
                "value": reportValue,
                "op": "=",
                "join": "AND"
            } : {
                "field": "runassessmentid",
                "value": props.match.params.runassessmentid,
                "op": "=",
                "join": "AND"
            }
         ],
        sort: [{ "field": "id", "direction": "asc" }],
        pagination: true,
    });

    useEffect(() => {
        let assessmentId = props?.location?.state?.assessment?.assessmentid;
        if ( assessmentId ) {
            getApi(`${assessmentDetail}${assessmentId}`).then((response) => {
                const assessmentRunListData = response.data.data;

                // TODO need to get assessment id from backend. If the tab is closed and the link is opened in another tab the props details will be gone.
                setassessment({...assessmentRunListData,...props?.location?.state?.assessment})
            
            }).catch((error) => {
                console.log(error);
            });
        }
      return () => {
      }
    }, []);

    const dataTable = createRef();

    const bulkPublish = () => {
        putApi(resultBulkPublish, { data: { resultids: publishResultIds } }).then(response => {
            setPublishResultIds([]);
            dataTable.current?.searchData([]);
        }).catch(error => {
            console.log(error);
        });
    };

    const bulkUnPublish = () => {
        putApi(resultBulkUnPublish, { data: { resultids: unPublishResultIds } }).then(response => {
            setUnPublishResultIds([]);
            dataTable.current?.searchData([]);
        }).catch(error => {
            console.log(error);
        });
    };

    return (
        <div className="run-assessment-client-list">
            <div className='d-flex align-items-center gap-2'>
                <img style={{width: '1.5rem'}} className="cursor-pointer" src={`${process.env.PUBLIC_URL}/static/images/back.png`} alt={"back"} onClick={()=>{props.history.goBack();}}/>
                <text className='font-weight-bold m-0'>{reportValue ? 'Assessment Report Status' : 'Assessment Status'}</text>
            </div>
            {/* <div className='d-flex justify-content-between align-items-center mx-5'>
                <Button className="btn btn-primary" onClick={() => { }}>Previous</Button>
                <Button className="btn btn-primary" onClick={() => { }}>Next</Button>
            </div> */}
            { !reportValue && <div className="d-flex flex-column bg-grey-light m-3 p-3 gap-3 detailview">
                <div className="d-flex gap-5">
                    <div className="d-flex gap-2 w-100">
                        <div className="font-weight-bold">Assessment Name</div>
                        {assessment.assessmentname}
                    </div>
                    <div className="d-flex gap-2 w-50">
                        <div className="font-weight-bold">Subject</div>
                        {assessment.subject}
                    </div>
                    <div className="d-flex gap-2 w-50">
                        <div className="font-weight-bold">Department</div>
                        {assessment.departmenttitle}
                    </div>
                </div>
                <div className="d-flex gap-5">
                    <div className="d-flex gap-2 w-100"><div className="font-weight-bold">Description</div> {assessment.subtitle}</div>
                    <div className="d-flex gap-2 w-50"><div className="font-weight-bold">Assessor</div> {assessment.creatorfirstname} {assessment.creatorlastname}</div>
                    <div className="d-flex gap-2 w-50"><div className="font-weight-bold">Status</div> {assessment.runstatus}</div>
                </div>
            </div> }

            <div className="d-flex justify-content-end py-2 gap-2">
                <Button disabled={publishResultIds.length === 0} onClick={bulkPublish}>{`Publish (${publishResultIds.length})`}</Button>
                <Button disabled={unPublishResultIds.length === 0} onClick={bulkUnPublish}>{`Un Publish (${unPublishResultIds.length})`}</Button>
            </div>

            
            {/* <div className='d-flex w-100 justify-content-end align-items-center gap-2 '>
                <div>Total <text className="text-primary font-weight-bold">150</text> Students</div>
                <img className={"mx-2 "} width={"25px"} src={`${process.env.PUBLIC_URL}/static/images/menudots.png`} alt={"menudots"} style={{
                    transform: 'rotate(90deg)'
                }} />
            </div> */}
            <Datatable ref={dataTable} config={config} />
        </div>
    );
};

export default RunAssessmentClientView;